namespace Seac.Commons {
	/** Configurazione della pagina prima di un cambio di visualizzazione */
	export class PreChangePageConfiguration {
		private _leftMenuOpened:	boolean;
		private _hidObjects: JQuery;
		private _showedObjects:	JQuery;

		public get leftMenuOpened(): boolean {
			return this._leftMenuOpened;
		}
		public get hidObjects(): JQuery {
			return this._hidObjects;
		}
		public get showedObjects(): JQuery {
			return this._showedObjects;
		}

		constructor(leftMenuOpen: boolean, hidObjects: JQuery, showedObjects: JQuery) {
			this._leftMenuOpened	= leftMenuOpen;
			this._hidObjects		= hidObjects;
			this._showedObjects		= showedObjects;
		}
	}
	/** Delegato per il callback dell'invio dei dati */
	export interface SendFormCallback {
		(data: any, status: JQuery.Ajax.SuccessTextStatus, xhr: JQuery.jqXHR<any>): void;
	}
 
	export abstract class BasePage<TPageConfiguration extends object> {
		public abstract pageConfiguration: TPageConfiguration;
		private _minVisibleWidth				: number;
		private _skipActionFormInAjax			: boolean = false;
		private _enableOnAjaxSubmit				: boolean = false;
		private _enableOnAjaxSubmitIdentifier	: string;

		public init(): void {
			if (this._minVisibleWidth && Seac.Pages.PageUtility.isMobileDevice) {
				// Se è settata una dimensione minima per la pagina, e mi trovo su un dispositivo mobile
				// richiamo il metodo che verifica che la risoluzione sia supportata,
				// eseguo anche il binding all'evento `orientationchange` del dispositivo per verificare che la "nuova" risoluzione sia compatibile con la pagina
				this.checkResolutionForPage();

				$(window).on(Seac.Commons.Constants.orientationChangeEvent, ()=> {
					this.checkResolutionForPage();
				});
			}
		}

		/** Controllo se la risoluzione è supportata per la pagina corrente, e visualizzo o nascondo il relativo overlay */
		private checkResolutionForPage(): void {
			let width: number;
			let height: number;

			// Se il dispositivo è in verticale larghezza e altezza sono corrette, altrimenti vanno invertite
			if (window.orientation == 0) {
				width = screen.availWidth;
				height = screen.availHeight;
			}else {
				// Sembra che i vari dispositivi restituiscano larghezza o altezza invertite, quindi prendo sempre per larghezza la dimensione maggiore
				width = screen.availHeight > screen.availWidth ? screen.availHeight : screen.availWidth;
				height = screen.availHeight > screen.availWidth ? screen.availWidth : screen.availHeight;
			}
			if (width < this._minVisibleWidth && height < this._minVisibleWidth) {
				// Se sono in questo caso significa che la risoluzione è troppo bassa per visualizzare la pagina
				// quindi mostro l'overlay con il messaggio che la pagina non è visibile su questo dispositivo
				Seac.Pages.PageUtility.showResolutionOverlay(Seac.Pages.ResolutionOverlayType.NotSupported);
			}else if (width < this._minVisibleWidth && height >= this._minVisibleWidth) {
				// Se l'altezza è maggiore della larghezza e sono su un dispositovo mobile, probabilmente l'utente può ruotare lo schermo
				// quindi mostro l'overlay con il messaggio di ruotare lo schermo
				Seac.Pages.PageUtility.showResolutionOverlay(Seac.Pages.ResolutionOverlayType.RotateDevice);
			}else {
				Seac.Pages.PageUtility.removeResolutionOverlay();
			}
		}

		/**
		 * Richiama un'azione disabilitando i pulsanti e li riattiva al termine dell'operazione
		 * @param action Azione da eseguire
		 * @param disableIdentifierArray Array di classi che devono essere disabilitate
		 */
		protected callActionDisableButtons(action: JQuery.Promise<boolean | null | void> & JQueryPromise<boolean | null | void>, ...disableIdentifierArray: Array<string>): JQuery.Promise<boolean | null | void> & JQueryPromise<boolean | null | void> {
			const disableIdentifier: string = Seac.Commons.FormUtility.disableAndMarkDescendantButtons($(Seac.Commons.Constants.body), ...disableIdentifierArray);
			return action.always((enableButtons: boolean | null | void) => {
				if (enableButtons !== false) {
					Seac.Commons.FormUtility.reEnableButtons($(Seac.Commons.Constants.body), disableIdentifier);
				}
			});
		}

		/** Imposta l'azione della form in ajax e non in nativo */
		protected actionFormInAjax(successCallback?: SendFormCallback, redirectCallback?: SendFormCallback, errorCallback?: SendFormCallback) {
			$('form').each((_, formElement: HTMLFormElement) => {
				$(formElement).on(Seac.Commons.Constants.submitEvent, (event: JQuery.SubmitEvent) => {
					// Controllo se effettuare l'action della form in ajax
					if (this._skipActionFormInAjax) {
						return ;
					}
					event.stopPropagation();
					event.preventDefault();
					
					// Prima di inviare i dati, verifico che l'impresa sia coerente
					if (Seac.Pages.sessionStateUtility.checkImpresaOnPost()) {
						// Serializzo la form per l'invio dei dati
						const serializedForm = this.serializeFormToFormData(
							<JQuery<HTMLFormElement>>$(formElement)	
						);

						const formAjaxService: FormAjaxService = new FormAjaxService();
						// Effettuo la post della form
						formAjaxService.sendForm(
							formElement.method,
							serializedForm,
							formElement.action
						).then((data: any, status: JQuery.Ajax.SuccessTextStatus, xhr: JQuery.jqXHR<any>) => {
							// Controllo quale evento di callback richiamare
							if (successCallback && (xhr.status >= Seac.Commons.HttpStatusCodes.OK_RANGE.from) && (xhr.status <= Seac.Commons.HttpStatusCodes.OK_RANGE.to)) {
								successCallback(data, status, xhr);
							}else if (redirectCallback && (xhr.status >= Seac.Commons.HttpStatusCodes.REDIRECT_RANGE.from) && (xhr.status <= Seac.Commons.HttpStatusCodes.REDIRECT_RANGE.to)) {
								redirectCallback(data, status, xhr);
							}else if (errorCallback &&
								(
									(xhr.status >= Seac.Commons.HttpStatusCodes.WARNING_RANGE.from) && (xhr.status <= Seac.Commons.HttpStatusCodes.WARNING_RANGE.to) ||
									(xhr.status >= Seac.Commons.HttpStatusCodes.ERROR_RANGE.from) && (xhr.status <= Seac.Commons.HttpStatusCodes.ERROR_RANGE.to)
								)
							) {
								errorCallback(data, status, xhr);
							}
						})
						.always(() => {
							// Controllo se abilitare i pulsanti submit
							this.submitEnableButtons();
						});
					}
				});
			});
		}

		/** Abilita la gestione dell'action della form in ajax */
		protected enableActionFormInAjax(): void {
			this._skipActionFormInAjax = false;
		}

		/** Disabilita la gestione dell'action della form in ajax */
		protected disableActionFormInAjax(): void {
			this._skipActionFormInAjax = true;
		}

		/**
		 * Serializza gli input presenti nella form, aggiunge gli eventuali file e restituisce il FormData
		 * @param formInstance Form da serializzare
		 */
		protected serializeFormToFormData(formInstance: JQuery<HTMLFormElement>): FormData {
			// Rimuovo le vecchie validazioni
			Seac.Commons.validationDisplay.cleanValidations();
			// Abilito tutti i field in modo che vengano serializzati correttamente
			const enableIdentifier: string = Seac.Commons.FormUtility.enableAndMarkDescendantInputFields(formInstance);

			const formData: FormData = new FormData();
			const formParams: Array<JQuery.NameValuePair> = formInstance.serializeArray();
			// Converte i dati della form in form data
			$.each(formParams, (_, nameValuePair: JQuery.NameValuePair) => {
				formData.append(nameValuePair.name, nameValuePair.value);
			});

			// Aggiunge gli eventuali allegati al form data
			$.each(formInstance.find('input[type="file"]'), (_, inputFileElement: HTMLElement) => {
				$.each((<HTMLInputElement>inputFileElement).files, (_, fileElement) => {
					formData.append((<HTMLInputElement>inputFileElement).name, fileElement);
				});
			});

			// Reimposto lo stato dei field ripristinando la situazione precedente all'abilitazione massiva			
			Seac.Commons.FormUtility.reDisableFormFields(formInstance, enableIdentifier);

			return formData;
		}

		/**
		 * Serializza gli input presenti nella form, restituendo un oggetto contenente i dati
		 * @param formInstance Form da serializzare
		 */
		protected serializeFormToObject<T>(formInstance: JQuery<HTMLFormElement>): T {
			// Abilito tutti i field in modo che vengano serializzati correttamente
			const enableIdentifier: string = Seac.Commons.FormUtility.enableAndMarkDescendantInputFields(formInstance);

			const serializedData: T = formInstance.serializeJSON<T>({useIntKeysAsArrayIndex: true, checkboxUncheckedValue: 'false', parseNumbers: false, parseBooleans: true, parseWithFunction: (val: any, inputName: string) => this.customFieldsSerializer(val, inputName) })

			// Reimposto lo stato dei field ripristinando la situazione precedente all'abilitazione massiva			
			Seac.Commons.FormUtility.reDisableFormFields(formInstance, enableIdentifier);

			return serializedData;
		}

		/**
		 * Metodo che permette la serializzazione custom degli input se necessario
		 * @param value Valore dell'input
		 * @param inputName Nome dell'input
		 */
		protected customFieldsSerializer(value: any, inputName: string): any {
			return value;
		}

		public setMinVisibleWidth(width: number): void {
			this._minVisibleWidth = width;
		}

		/** Disabilita tutti i pulsanti submit al submit di una form */
		protected submitDisableButtonsOnEvent(enableOnAjaxSubmit?: boolean): void {
			this._enableOnAjaxSubmit = !!enableOnAjaxSubmit;

			$('form').on(Seac.Commons.Constants.submitEvent, (event: JQuery.SubmitEvent) => {
				// Salvo l'identificatore di disabilitazione
				this._enableOnAjaxSubmitIdentifier = Seac.Commons.FormUtility.disableAndMarkElement($(':submit'));
			});
		}

		/** Abilita i pulsanti submit immediatamente */
		protected submitEnableButtons(): void {
			// Solo se abilitato alla riabilitazione in form in ajax abilito gli elementi disabilitati
			if (!this._enableOnAjaxSubmit || !this._enableOnAjaxSubmitIdentifier) {
				return ;
			}
			Seac.Commons.FormUtility.reEnableElement($(':submit'), this._enableOnAjaxSubmitIdentifier);
		}
	}
}
